import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icons/token.svg'
import _imports_1 from '@/assets/img/icons/plus-yellow.svg'
import _imports_2 from '@/assets/img/icons/plus-black.svg'
import _imports_3 from '@/assets/img/icons/empty-project.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-base leading-6 font-semibold tracking-wider text-blue-900" }, " Token anda ", -1)
const _hoisted_2 = { class: "flex p-4 gap-4 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-8"
}, null, -1)
const _hoisted_4 = { class: "text-3xl leading-9 font-bold tracking-wider text-gray-900" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "ml-2 px-4 py-2 bg-transparent border-1 border-yellow-400 rounded text-yellow-400 text-sm leading-6 font-semibold flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createTextVNode(" Top Up ")
], -1)
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-base leading-6 font-semibold tracking-wider text-blue-900" }, " Proyek saya ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full bg-gray-200 h-24 rounded-lg mb-4" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-full bg-gray-200 h-24 rounded-lg mb-4" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-full bg-gray-200 h-24 rounded-lg mb-4" }, null, -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "flex gap-2 flex-col items-center justify-center mt-20"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-40 h-40 mb-4"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Anda belum memiliki Proyek", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "text-sm leading-6 text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_badge = _resolveComponent("badge")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.token), 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_router_link, {
          to: "/admin/project/create",
          class: "ml-2 px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" Buat Proyek ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.projects.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createVNode(_component_router_link, {
              to: "/admin/project/create",
              class: "ml-2 px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _createTextVNode(" Buat Proyek ")
              ]),
              _: 1
            })
          ]))
        : (_ctx.projects.length && !_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createElementBlock("div", {
                key: project.id,
                class: "rounded-lg border-1 border-gray-200 p-4 mb-4"
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                      to: `/admin/project/${project.id}`,
                      class: "text-xl leading-7 font-semibold tracking-wider text-gray-900 mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(project.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDateTime(project.started_at, "DD MMMM YYYY [00:00]")) + " - " + _toDisplayString(_ctx.formatDateTime(project.ended_at, "DD MMMM YYYY [23:59]")), 1)
                  ]),
                  _createVNode(_component_badge, {
                    variant: _ctx.getBadgeVariant(project.status),
                    label: project.status_label
                  }, null, 8, ["variant", "label"])
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true),
      (_ctx.page !== _ctx.lastPage && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
            class: "mt-4 block mx-auto p-2 text-blue-800 text-sm leading-6 font-semibold tracking-wider"
          }, " Lihat Lebih Banyak "))
        : _createCommentVNode("", true)
    ])
  ]))
}